import { SourceComponents } from '@updater/informant-core';
import { DatePickerInput } from '@updater/ui-uds';

export const DatePickerField: SourceComponents['DatePickerField'] = (props) => {
  return <DatePickerInput {...props} />;
};
